/* eslint-disable prefer-destructuring */
import { SurveyQuestionnaireDeerPage } from 'Deer/components/Engagement/SurveyFormFilling/SurveyQuestionnaireDeerPage';
import { SurveyResultDeerPage } from 'Deer/components/Engagement/SurveyResult/SurveyResultDeerPage';
import { getUserAccess } from 'Deer/helpers/getUserAccess';
import { CheckInGoalsIntentLandingPage } from 'Deer/intent/Goals/CheckInGoalsIntentLandingPage';
import { UploadGoalsIntentLandingPage } from 'Deer/intent/Goals/UploadGoalsIntentLandingPage';
import { LifecycleHire } from 'Deer/pages/Company/Analytics/Lifecycle/LifecycleHire';
import { LifecycleOnboard } from 'Deer/pages/Company/Analytics/Lifecycle/LifecycleOnboard';
import { LifecycleProgress } from 'Deer/pages/Company/Analytics/Lifecycle/LifecycleProgress';
import { LifecycleRetire } from 'Deer/pages/Company/Analytics/Lifecycle/LifecycleRetire';
import { MyCompanyOverview } from 'Deer/pages/Company/CompanyOverview/MyCompanyOverview';
import { CompensationCycleCreation } from 'Deer/pages/Company/Compensation/CompensationCycleCreation';
import { CompensationRecommendation } from 'Deer/pages/Company/Compensation/CompensationRecommendation';
import MyCompanyCompensationPlanning from 'Deer/pages/Company/Compensation/Planning';
import { CompensationSettings } from 'Deer/pages/Company/Compensation/Settings';
import { CompetencyLibrary } from 'Deer/pages/Company/Develop/CompetencyLibrary';
import { CompetencySettings } from 'Deer/pages/Company/Develop/CompetencySettings';
import CompanyDevelopInsights from 'Deer/pages/Company/Develop/DevelopInsights';
import DevelopSettings from 'Deer/pages/Company/Develop/DevelopSettings';
import { EmbeddedDevelopAnalytics } from 'Deer/pages/Company/Develop/EmbeddedDevelopAnalytics';
import { MyCompanyAdminReports } from 'Deer/pages/Company/DisciplinaryActions/MyCompanyAdminReports';
import { MyCompanyAllDisciplinaryActions } from 'Deer/pages/Company/DisciplinaryActions/MyCompanyAllDisciplinaryActions';
import { MyCompanyDisciplinaryActionsSettings } from 'Deer/pages/Company/DisciplinaryActions/MyCompanyDisciplinaryActionsSettings';
import { MyCompanyPendingDisciplinaryActions } from 'Deer/pages/Company/DisciplinaryActions/MyCompanyPendingDisciplinaryActions';
import { EmbeddedEngagementAnalytics } from 'Deer/pages/Company/Engagement/EmbeddedEngagementAnalytics';
import { EngagementSettings } from 'Deer/pages/Company/Engagement/EngagementSettings';
import MyCompanyEngagementInsights from 'Deer/pages/Company/Engagement/MyCompanyEngagement';
import MyCompanyEngagementCompletionStatus from 'Deer/pages/Company/Engagement/MyCompanyEngagementCompletionStatus';
import { SurveyCreation } from 'Deer/pages/Company/Engagement/Surveys/SurveyCreation';
import { SurveyPreview } from 'Deer/pages/Company/Engagement/Surveys/SurveyPreview';
import { EmbeddedGoalsAnalytics } from 'Deer/pages/Company/Goals/EmbeddedGoalsAnalytics';
import { GoalsArchived } from 'Deer/pages/Company/Goals/GoalsArchived';
import { GoalsDataExportsReport } from 'Deer/pages/Company/Goals/GoalsDataExportsReport';
import IndividualsGoals from 'Deer/pages/Company/Goals/IndividualsGoals';
import CompanyManageGoals from 'Deer/pages/Company/Goals/Manage';
import CompanyGoalsSettings from 'Deer/pages/Company/Goals/Settings';
import CompanyOneOnOneDataExportsIntent from 'Deer/pages/Company/OneOnOne/CompanyOneOnOneDataExportsIntent';
import CompanyOneOnOneInsights from 'Deer/pages/Company/OneOnOne/CompanyOneOnOneInsights';
import { EmbeddedOneOnOneAnalytics } from 'Deer/pages/Company/OneOnOne/EmbeddedOneOnOneAnalytics';
import CompanyOneOnOneSettings from 'Deer/pages/Company/OneOnOne/Settings';
import CompanyCalibrationViews from 'Deer/pages/Company/Reviews/CompanyCalibrationViews';
import { CompanyReviewDetailedReport } from 'Deer/pages/Company/Reviews/CompanyReviewDetailedReport';
import CompanyReviewsManage from 'Deer/pages/Company/Reviews/CompanyReviewsManage';
import { EmbeddedReviewsAnalytics } from 'Deer/pages/Company/Reviews/EmbeddedReviewsAnalytics';
import { ReviewSettings } from 'Deer/pages/Company/Reviews/ReviewSettings';
import { NextCheckIn } from 'Deer/pages/MyData/CheckIns/NextCheckIn';
import { PastCheckIn } from 'Deer/pages/MyData/CheckIns/PastCheckIn';
import MyCompetencies from 'Deer/pages/MyData/Develop/MyCompetencies/MyCompetencies';
import MyFeedback from 'Deer/pages/MyData/Develop/MyFeedback/MyFeedback';
import { OrgPraises } from 'Deer/pages/MyData/Develop/OrgPraises/OrgPraises';
import { MyDataDisciplinaryActions } from 'Deer/pages/MyData/DisciplinaryActions/MyDataDisciplinaryActions';
import MySurveys from 'Deer/pages/MyData/Engagement/MySurveys/MySurveys';
import MyDataIndividualsGoals from 'Deer/pages/MyData/Goals/IndividualsGoals/MyDataIndividualGoals';
import MyCompany from 'Deer/pages/MyData/Goals/MyCompany/MyCompany';
import MyGoals from 'Deer/pages/MyData/Goals/MyGoals/MyGoals';
import MyInitiatives from 'Deer/pages/MyData/Initiatives/MyInitiatives/MyInitiatives';
import LegacyInstancePage from 'Deer/pages/MyData/OneOnOne/LegacyInstancePage/LegacyInstancePage';
import { OneOnOneMasterPage } from 'Deer/pages/MyData/OneOnOne/MasterPage/OneOnOneMasterPage';
import MyOneOnOne from 'Deer/pages/MyData/OneOnOne/MyOneOnOne/MyOneOnOne';
import OneOnOneInstancePage from 'Deer/pages/MyData/OneOnOne/OneOnOneInstancePage/OneOnOneInstancePage';
import MyDataOverview from 'Deer/pages/MyData/Overview/MyOverview';
import ReviewsExplore from 'Deer/pages/MyData/Reviews/ReviewsExplore/ReviewsExplore';
import { AllReportsDevelopEmbeddedAnalytics } from 'Deer/pages/Team/AllReports/Develop/AllReportsDevelopEmbeddedAnalytics';
import AllReportsDevelopInsights from 'Deer/pages/Team/AllReports/Develop/AllReportsDevelopInsights';
import AllReportsProfile from 'Deer/pages/Team/AllReports/Employee/Profile/AllReportsProfile';
import AllReportsEngagementInsights from 'Deer/pages/Team/AllReports/Engagement/AllReportsEngagementInsights';
import { AllReportGoalsEmbeddedAnalytics } from 'Deer/pages/Team/AllReports/Goals/AllReportGoalsEmbeddedAnalytics';
import AllReportsGoalsInsights from 'Deer/pages/Team/AllReports/Goals/Insights';
import AllReportsManageGoals from 'Deer/pages/Team/AllReports/Goals/Manage';
import { AllReportOneOnOneEmbeddedAnalytics } from 'Deer/pages/Team/AllReports/OneOnOne/AllReportOneOnOneEmbeddedAnalytics';
import AllReportsIndividualsGoals from 'Deer/pages/Team/AllReports/OneOnOne/AllReportsIndividualsGoals';
import AllReportsInsightsOneOnOne from 'Deer/pages/Team/AllReports/OneOnOne/AllReportsInsightsOneOnOne';
import AllReportsInstancePage from 'Deer/pages/Team/AllReports/OneOnOne/AllReportsInstancePage';
import AllReportsManageOneOnOne from 'Deer/pages/Team/AllReports/OneOnOne/AllReportsManageOneOnOne';
import AllReportsOneOnOneDataExportsIntent from 'Deer/pages/Team/AllReports/OneOnOne/AllReportsOneOnOneDataExportsIntent';
import { AllReportReviewsEmbeddedAnalytics } from 'Deer/pages/Team/AllReports/Reviews/AllReportReviewsEmbeddedAnalytics';
import { AllReportsReviewDetailedReport } from 'Deer/pages/Team/AllReports/Reviews/AllReportsReviewDetailedReport';
import AllReportsReviewsManage from 'Deer/pages/Team/AllReports/Reviews/AllReportsReviewsManage';
import { MySkipTeamOverview } from 'Deer/pages/Team/AllReports/SkipTeamOverview/MySkipTeamOverview';
import { DirectReportsDevelopEmbeddedAnalytics } from 'Deer/pages/Team/DirectReports/Develop/DirectReportsDevelopEmbeddedAnalytics';
import { DirectReportsDevelopFeedbackForMyTeam } from 'Deer/pages/Team/DirectReports/Develop/DirectReportsDevelopFeedbackForMyTeam';
import DirectReportsDevelopInsights from 'Deer/pages/Team/DirectReports/Develop/DirectReportsDevelopInsights';
import DirectReportsDevelopManage from 'Deer/pages/Team/DirectReports/Develop/DirectReportsDevelopManage';
import { MyTeamOverview } from 'Deer/pages/Team/DirectReports/DirectReportsOverview/MyTeamOverview';
import { MyTeamsDisciplinaryActions } from 'Deer/pages/Team/DirectReports/DisciplinaryActions/MyTeamsDisciplinaryActions';
import DirectReportsProfile from 'Deer/pages/Team/DirectReports/Employee/Profile/DirectReportsProfile';
import DirectReportsEngagementInsights from 'Deer/pages/Team/DirectReports/Engagement/DirectReportsEngagementInsights';
import { DirectReportGoalsEmbeddedAnalytics } from 'Deer/pages/Team/DirectReports/Goals/DirectReportGoalsEmbeddedAnalytics';
import DirectReportsIndividualsGoals from 'Deer/pages/Team/DirectReports/Goals/DirectReportsIndividualsGoals';
import DirectReportsManageGoals from 'Deer/pages/Team/DirectReports/Goals/DirectReportsManageGoals';
import DirectReportsGoalsInsights from 'Deer/pages/Team/DirectReports/Goals/Insights';
import { DirectReportOneOnOneEmbeddedAnalytics } from 'Deer/pages/Team/DirectReports/OneOnOne/DirectReportOneOnOneEmbeddedAnalytics';
import DirectReportsInsightsOneOnOne from 'Deer/pages/Team/DirectReports/OneOnOne/DirectReportsInsightsOneOnOne';
import DirectReportsInstancePage from 'Deer/pages/Team/DirectReports/OneOnOne/DirectReportsInstancePage';
import DirectReportsOneOnOneDataExportsIntent from 'Deer/pages/Team/DirectReports/OneOnOne/DirectReportsOneOnOneDataExportsIntent';
import { DirectReportReviewsEmbeddedAnalytics } from 'Deer/pages/Team/DirectReports/Reviews/DirectReportReviewsEmbeddedAnalytics';
import { DirectReportsReviewDetailedReport } from 'Deer/pages/Team/DirectReports/Reviews/DirectReportsReviewDetailedReport';
import DirectReportsReviewsActionPlan from 'Deer/pages/Team/DirectReports/Reviews/DirectReportsReviewsActionPlan';
import DirectReportsReviewsManage from 'Deer/pages/Team/DirectReports/Reviews/DirectReportsReviewsManage';
import ViewsManageGoals from 'Deer/pages/Team/View/Goals/ViewsManageGoals';
import ViewsCalibrationViews from 'Deer/pages/Team/View/Reviews/ViewsCalibrationViews';
import ViewsReviewsManage from 'Deer/pages/Team/View/Reviews/ViewsReviewsManage';
import ViewsReviewsReports from 'Deer/pages/Team/View/Reviews/ViewsReviewsReports';
import { ReviewProcessV2Intent } from 'screens/admin/Reviews/ReviewProcessV2Intent';
import ReviewActionPlan from 'screens/performanceReview/manageAndInsights/ReviewActionPlan/ReviewActionPlan';
import {
  checkBulkCheckInEnabled,
  checkBulkUploadIntentEnabled,
  checkIntentLandingPagesFeatureEnabled,
  checkLifecycleInsightsEnabled,
  checkVisierAnalyticsEnabled,
  checkReviewReportsEnabled,
  checkGoalDataExportsReportEnabled,
  checkSimplifiedReviewCreationEnabled,
} from 'utils/helpers/featureFlags';

import { isNetchexLogin } from 'constants/netChexConstants';

import { type L3_CONTENT_TYPE } from './types/L3Content';

export const calcHasReviewSettingsAccess = () => {
  const isReviewAdmin = getUserAccess().isReviewAdmin;

  if (isReviewAdmin) {
    return true;
  }
  const isCustomReviewAdmin = getUserAccess().isCustomReviewAdmin;
  const isEnableConfigureReviewIntentForCustomAdmin = checkSimplifiedReviewCreationEnabled();

  if (isCustomReviewAdmin && isEnableConfigureReviewIntentForCustomAdmin) {
    return true;
  }

  return false;
};

export const L3_CONTENT: L3_CONTENT_TYPE = {
  'my-data': {
    overview: {
      myDataOverview: {
        label: 'My data overview',
        content: MyDataOverview,
        cohortId: -12,
        teamId: -12,
      },
    },
    checkIns: {
      nextCheckIns: { label: 'My Check-ins', content: NextCheckIn },
      pastCheckIns: { label: 'Past Check-ins', content: PastCheckIn },
    },
    goal: {
      myGoals: { label: 'My', headerLabel: 'My', content: MyGoals, cohortId: -12, teamId: -12 },
      // myTeam: {
      //   label: 'My Team',
      //   content: () => <AgGridTreeView isHierarchyView={false} />,
      //   cohortId: -12,
      //   teamId: -12,
      // },

      // myDepartment: {
      //   label: 'My Department',
      //   content: DepartmentViewContainer,
      //   cohortId: -12,
      //   teamId: -12,
      // },

      myCompany: {
        label: 'Company-wide',
        headerLabel: 'Company-wide',
        content: MyCompany,
        cohortId: isNetchexLogin ? -14 : -1,
        teamId: isNetchexLogin ? -14 : -1,
      },
      individualsGoals: {
        label: '',
        content: MyDataIndividualsGoals,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
      },
      checkIn: {
        label: 'Check-in',
        headerLabel: 'My',
        content: CheckInGoalsIntentLandingPage,
        cohortId: -12,
        teamId: -12,
        hide: () => !checkBulkCheckInEnabled(),
      },
      upload: {
        label: 'Upload',
        headerLabel: 'Upload',
        content: UploadGoalsIntentLandingPage,
        cohortId: -12,
        teamId: -12,
        hide: () => !checkBulkUploadIntentEnabled(),
      },
    },
    oneOnOne: {
      myOneOnOne: { label: 'My 1:1s', content: MyOneOnOne, cohortId: -9, teamId: -9 },
      instancePage: {
        label: 'Instance page',
        content: OneOnOneInstancePage,
        cohortId: -9,
        teamId: -9,
      },
      masterPage: {
        label: 'Master page',
        content: OneOnOneMasterPage,
        cohortId: -9,
        teamId: -9,
        hideFromTabList: true,
      },
      legacyPage: {
        label: 'Legacy page',
        content: LegacyInstancePage,
        cohortId: -9,
        teamId: -9,
        hideFromTabList: true,
      },
    },
    develop: {
      feedback: { label: 'My feedback', content: MyFeedback },
      competencies: {
        label: 'My competencies',
        content: MyCompetencies,
        cohortId: -13,
        teamId: -13,
      },
      organisationPraise: {
        label: "Organisation's praise",
        hideFromTabList: true,
        content: OrgPraises,
        cohortId: -1,
        teamId: -1,
      },
    },
    initiative: {
      myInitiatives: {
        label: 'My initiatives',
        content: MyInitiatives,
        cohortId: -11,
        teamId: -11,
        type: 'MY_INITIATIVES',
      },
    },
    engagement: {
      mySurveys: { label: 'My surveys', content: MySurveys },
      activeSurvey: { label: 'Active survey', content: SurveyQuestionnaireDeerPage },
      submittedSurvey: { label: 'Submitted survey', content: SurveyResultDeerPage },
    },
    disciplinaryActions: {
      pendingDisciplinaryActions: {
        label: 'Pending disciplinary actions',
        content: MyDataDisciplinaryActions,
        cohortId: -1,
        teamId: -1,
      },
      allDisciplinaryActions: {
        label: 'All disciplinary actions',
        content: MyDataDisciplinaryActions,
        cohortId: -1,
        teamId: -1,
      },
    },
    review: { myReviews: { label: 'My reviews', content: ReviewsExplore } },
  },
  team: {
    allReports: {
      overview: {
        mySkipTeamOverview: {
          label: 'My skip team overview',
          content: MySkipTeamOverview,
          cohortId: -3,
          teamId: -3,
        },
      },
      goal: {
        manage: {
          label: 'Manage',
          headerLabel: "My skip team's",
          content: AllReportsManageGoals,
          cohortId: -3,
        },
        insights: {
          label: 'Insights',
          headerLabel: "My skip team's",
          content: AllReportsGoalsInsights,
          cohortId: -3,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My skip team's",
          content: AllReportGoalsEmbeddedAnalytics,
          cohortId: -3,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        individualsGoals: {
          label: 'Individuals goals',
          content: AllReportsIndividualsGoals,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
        checkIn: {
          label: 'Check-in',
          headerLabel: "My skip team's",
          content: CheckInGoalsIntentLandingPage,
          hide: () => !checkBulkCheckInEnabled(),
          cohortId: -3,
        },
        upload: {
          label: 'Upload',
          headerLabel: 'Upload',
          content: UploadGoalsIntentLandingPage,
          cohortId: -3,
          hide: () => !checkBulkUploadIntentEnabled(),
        },
      },
      develop: {
        manage: {
          label: 'Manage',
          headerLabel: "My skip team's competencies",
          content: () => <div>Manage</div>,
          cohortId: -12,
          teamId: -12,
        },
        insights: {
          label: 'Insights',
          headerLabel: "My skip team's competencies",
          content: AllReportsDevelopInsights,
          cohortId: -3,
          teamId: -3,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My skip team's competencies",
          content: AllReportsDevelopEmbeddedAnalytics,
          cohortId: -3,
          teamId: -3,
          hide: () => !checkVisierAnalyticsEnabled() || !checkIntentLandingPagesFeatureEnabled(),
        },
      },
      oneOnOne: {
        manage: { label: 'Manage', content: AllReportsManageOneOnOne, cohortId: -3, teamId: -3 },
        insights: {
          label: "Team's 1:1 performance",
          content: AllReportsInsightsOneOnOne,
          cohortId: -3,
          teamId: -3,
        },
        instancePage: {
          label: 'Instance page',
          content: AllReportsInstancePage,
          cohortId: -3,
          teamId: -3,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My skip team's 1:1's",
          content: AllReportOneOnOneEmbeddedAnalytics,
          cohortId: -3,
          teamId: -3,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        masterPage: {
          label: 'Master page',
          content: OneOnOneMasterPage,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
        legacyPage: {
          label: 'Legacy page',
          content: LegacyInstancePage,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
        dataExports: {
          label: 'Data exports',
          headerLabel: "My skip team's 1:1s",
          content: AllReportsOneOnOneDataExportsIntent,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
      },
      review: {
        manage: { label: 'Manage', content: AllReportsReviewsManage, cohortId: -3, teamId: -3 },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My skip team's reviews",
          content: AllReportReviewsEmbeddedAnalytics,
          cohortId: -3,
          teamId: -3,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        detailReports: {
          label: 'Reports',
          headerLabel: "My skip team's reviews",
          content: AllReportsReviewDetailedReport,
          cohortId: -3,
          teamId: -3,
          hide: () => !checkReviewReportsEnabled(),
        },

        calibratedResults: {
          label: 'Calibrated results',
          content: AllReportsReviewsManage,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
        completionStatus: {
          label: 'Completion status',
          content: AllReportsReviewsManage,
          cohortId: -3,
          teamId: -3,
          hideFromTabList: true,
        },
      },
      engagement: {
        insights: {
          label: 'Insights',
          headerLabel: 'My organization',
          content: AllReportsEngagementInsights,
          cohortId: -3,
          teamId: -3,
        },
      },
      employee: {
        profilePage: {
          label: 'Profile page',
          content: AllReportsProfile,
        },
      },
      disciplinaryActions: {
        pendingDisciplinaryActions: {
          label: 'Pending disciplinary actions',
          content: MyTeamsDisciplinaryActions,
          cohortId: -3,
          teamId: -3,
        },
        allDisciplinaryActions: {
          label: 'All disciplinary actions',
          content: MyTeamsDisciplinaryActions,
          cohortId: -3,
          teamId: -3,
        },
      },
      compensation: {
        planning: {
          label: 'Compensation planning',
          content: MyCompanyCompensationPlanning,
          cohortId: -3,
          teamId: -3,
        },
        compensationRecommendation: {
          label: 'Compensation recommendation',
          content: CompensationRecommendation,
          cohortId: -3,
          teamId: -3,
        },
      },
    },
    directReports: {
      overview: {
        myTeamOverview: {
          label: 'My direct team overview',
          content: MyTeamOverview,
          cohortId: -2,
          teamId: -2,
        },
      },
      goal: {
        manage: {
          label: 'Manage',
          headerLabel: "My direct team's",
          content: DirectReportsManageGoals,
          cohortId: -2,
        },
        insights: {
          label: 'Insights',
          headerLabel: "My direct team's",
          content: DirectReportsGoalsInsights,
          cohortId: -2,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My direct team's",
          content: DirectReportGoalsEmbeddedAnalytics,
          cohortId: -2,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        individualsGoals: {
          label: 'Individuals goals',
          content: DirectReportsIndividualsGoals,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
        checkIn: {
          label: 'Check-in',
          headerLabel: "My direct team's",
          content: CheckInGoalsIntentLandingPage,
          hide: () => !checkBulkCheckInEnabled(),
          cohortId: -2,
        },
        upload: {
          label: 'Upload',
          headerLabel: 'Upload',
          content: UploadGoalsIntentLandingPage,
          cohortId: -2,
          hide: () => !checkBulkUploadIntentEnabled(),
        },
      },
      develop: {
        manage: { label: 'Manage', content: DirectReportsDevelopManage, cohortId: -2, teamId: -2 },
        insights: {
          label: 'Insights',
          headerLabel: "My direct team's competencies",
          content: DirectReportsDevelopInsights,
          cohortId: -2,
          teamId: -2,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My direct team's competencies",
          content: DirectReportsDevelopEmbeddedAnalytics,
          cohortId: -2,
          teamId: -2,
          hide: () => !checkVisierAnalyticsEnabled() || !checkIntentLandingPagesFeatureEnabled(),
        },
        feedbackForMyTeam: {
          label: 'Feedback for my team',
          headerLabel: "My direct team's competencies",
          content: DirectReportsDevelopFeedbackForMyTeam,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
      },
      oneOnOne: {
        manage: {
          label: 'Manage',
          content: DirectReportsInsightsOneOnOne,
          cohortId: -2,
          teamId: -2,
        },
        instancePage: {
          label: 'Instance page',
          content: DirectReportsInstancePage,
          cohortId: -2,
          teamId: -2,
        },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My direct team's 1:1's",
          content: DirectReportOneOnOneEmbeddedAnalytics,
          cohortId: -2,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        masterPage: {
          label: 'Master page',
          content: OneOnOneMasterPage,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
        legacyPage: {
          label: 'Legacy page',
          content: LegacyInstancePage,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
        dataExports: {
          label: 'Data exports',
          headerLabel: "My direct team's 1:1s",
          content: DirectReportsOneOnOneDataExportsIntent,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
      },
      review: {
        manage: { label: 'Manage', content: DirectReportsReviewsManage, cohortId: -2, teamId: -2 },
        embeddedAnalytics: {
          label: 'Insights',
          headerLabel: "My direct team's reviews",
          content: DirectReportReviewsEmbeddedAnalytics,
          cohortId: -2,
          hide: () => !checkVisierAnalyticsEnabled(),
        },
        detailReports: {
          label: 'Reports',
          headerLabel: "My direct team's reviews",
          content: DirectReportsReviewDetailedReport,
          cohortId: -2,
          hide: () => !checkReviewReportsEnabled(),
        },
        calibratedResults: {
          label: 'Calibrated results',
          content: DirectReportsReviewsManage,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
        completionStatus: {
          label: 'Completion status',
          content: DirectReportsReviewsManage,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
        },
        actionPlan: {
          label: 'Action plan',
          content: DirectReportsReviewsActionPlan,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
          hide: () => false,
        },
        actionPlanEdit: {
          label: 'Action plan edit',
          content: ReviewActionPlan,
          cohortId: -2,
          teamId: -2,
          hideFromTabList: true,
          hide: () => false,
        },
      },
      engagement: {
        insights: {
          label: 'Insights',
          headerLabel: 'My direct team',
          content: DirectReportsEngagementInsights,
          cohortId: -2,
          teamId: -2,
        },
      },
      employee: {
        profilePage: {
          label: 'Profile page',
          content: DirectReportsProfile,
        },
      },
      disciplinaryActions: {
        pendingDisciplinaryActions: {
          label: 'Pending disciplinary actions',
          content: MyTeamsDisciplinaryActions,
          cohortId: -2,
          teamId: -2,
        },
        allDisciplinaryActions: {
          label: 'All disciplinary actions',
          content: MyTeamsDisciplinaryActions,
          cohortId: -2,
          teamId: -2,
        },
      },
      compensation: {
        planning: {
          label: 'Compensation planning',
          content: MyCompanyCompensationPlanning,
          cohortId: -2,
          teamId: -2,
        },
      },
    },
    view: {
      goal: {
        manage: { label: 'Manage', content: ViewsManageGoals, cohortId: -4, teamId: -4 },
        checkIn: {
          label: 'Check-in',
          content: CheckInGoalsIntentLandingPage,
          hide: () => !checkBulkCheckInEnabled(),
          cohortId: -4,
          teamId: -4,
        },
        upload: {
          label: 'Upload',
          content: UploadGoalsIntentLandingPage,
          hide: () => !checkBulkUploadIntentEnabled(),
          cohortId: -4,
          teamId: -4,
        },
        individualsGoals: {
          label: 'Individuals goals',
          content: IndividualsGoals,
          cohortId: -4,
          teamId: -4,
          hideFromTabList: true,
        },
      },
      review: {
        manage: { label: 'Manage', content: ViewsReviewsManage, cohortId: -4, teamId: -4 },
        calibrationView: {
          label: 'Calibration view',
          content: ViewsCalibrationViews,
          cohortId: -1,
          teamId: -1,
          hideFromTabList: true,
        },
        calibratedResults: {
          label: 'Calibrated results',
          content: ViewsReviewsManage,
          cohortId: -4,
          teamId: -4,
          hideFromTabList: true,
        },
        completionStatus: {
          label: 'Completion status',
          content: ViewsReviewsManage,
          cohortId: -4,
          teamId: -4,
          hideFromTabList: true,
        },
        detailReports: {
          label: 'Reports',
          content: ViewsReviewsReports,
          cohortId: -4,
          teamId: -4,
          hide: () => !checkReviewReportsEnabled(),
          hideFromTabList: true,
        },
      },
    },
  },
  company: {
    overview: {
      myCompanyOverview: {
        label: 'My company&apos;s overview',
        content: MyCompanyOverview,
        cohortId: -1,
        teamId: -1,
      },
    },
    goal: {
      manage: {
        label: 'Manage',
        headerLabel: "My company's",
        content: CompanyManageGoals,
        cohortId: -1,
        teamId: -1,
      },
      archived: {
        label: 'Archived',
        headerLabel: "My company's",
        content: GoalsArchived,
        cohortId: -1,
        teamId: -1,
      },
      settings: {
        label: 'Settings',
        headerLabel: "My company's",
        content: CompanyGoalsSettings,
        cohortId: -1,
        teamId: -1,
        hide: () => {
          if (isNetchexLogin) {
            return !getUserAccess().isGoalAdmin && !getUserAccess().isCustomGoalAdmin;
          }
          return !getUserAccess().isGoalAdmin;
        },
      },
      embeddedAnalytics: {
        label: 'Insights',
        headerLabel: "My company's",
        content: EmbeddedGoalsAnalytics,
        cohortId: -1,
        teamId: -1,
        hide: () => !(checkVisierAnalyticsEnabled() && getUserAccess().isGoalAdmin),
      },
      dataExports: {
        label: 'Data exports',
        headerLabel: "My company's",
        cohortId: -1,
        teamId: -1,
        hide: () =>
          !(checkGoalDataExportsReportEnabled() && (getUserAccess().isGoalAdmin || getUserAccess().isCustomGoalAdmin)),
        content: GoalsDataExportsReport,
      },

      individualsGoals: {
        label: 'Individuals goals',
        content: IndividualsGoals,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
      },
      checkIn: {
        label: 'Check-in',
        headerLabel: "My company's",
        content: CheckInGoalsIntentLandingPage,
        hide: () => !checkBulkCheckInEnabled(),
        cohortId: -1,
      },
      upload: {
        label: 'Upload',
        headerLabel: 'Upload',
        content: UploadGoalsIntentLandingPage,
        cohortId: -1,
        hide: () => !checkBulkUploadIntentEnabled(),
      },
    },
    develop: {
      insights: {
        label: 'Manage',
        headerLabel: "My company's competencies",
        content: CompanyDevelopInsights,
        cohortId: -1,
        teamId: -1,
      },
      // reports: {
      //   label: 'Reports',
      //   content: () => <div>Reports</div>,
      //   cohortId: -1,
      //   teamId: -1,
      // },
      settings: {
        label: 'Settings',
        headerLabel: "My company's competencies",
        content: DevelopSettings,
        cohortId: -1,
        teamId: -1,
        hide: () => !getUserAccess().isFeedbackAdmin,
      },
      embeddedAnalytics: {
        label: 'Insights',
        headerLabel: "My company's competencies",
        content: EmbeddedDevelopAnalytics,
        cohortId: -1,
        teamId: -1,
        hide: () => !(checkVisierAnalyticsEnabled() && getUserAccess().isFeedbackAdmin),
      },
      competencyLibrary: {
        label: 'Competency library',
        content: CompetencyLibrary,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: !getUserAccess().isFeedbackAdmin && !checkIntentLandingPagesFeatureEnabled(),
      },
      competencySettings: {
        label: 'Competency settings',
        content: CompetencySettings,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: !getUserAccess().isFeedbackAdmin && !checkIntentLandingPagesFeatureEnabled(),
      },
    },
    oneOnOne: {
      insights: { label: 'Manage', content: CompanyOneOnOneInsights, cohortId: -1, teamId: -1 },
      // reports: {
      //   label: 'Reports',
      //   content: () => <div>Reports</div>,
      //   cohortId: -1,
      //   teamId: -1,
      // },
      settings: {
        label: 'Settings',
        content: CompanyOneOnOneSettings,
        cohortId: -1,
        teamId: -1,
        headerLabel: "My company's 1:1s",
        hide: () => {
          if (isNetchexLogin) {
            return !getUserAccess().isOneOnOneAdmin && !getUserAccess().isCustomOneOnOneAdmin;
          }
          return !getUserAccess().isOneOnOneAdmin;
        },
      },
      // calender: {
      //   label: 'Calendar',
      //   content: CompanyOneOnOneCalender,
      //   cohortId: -1,
      //   teamId: -1,
      // },
      embeddedAnalytics: {
        label: 'Insights',
        headerLabel: "My company's 1:1s",
        content: EmbeddedOneOnOneAnalytics,
        cohortId: -1,
        teamId: -1,
        hide: () => !(checkVisierAnalyticsEnabled() && getUserAccess().isOneOnOneAdmin),
      },
      dataExports: {
        label: 'Data exports',
        headerLabel: "My company's 1:1s",
        content: CompanyOneOnOneDataExportsIntent,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
        hide: () => !(getUserAccess().isOneOnOneAdmin || getUserAccess().isCustomOneOnOneAdmin),
      },
    },
    review: {
      manage: { label: 'Manage', content: CompanyReviewsManage, cohortId: -1, teamId: -1 },
      calibrationView: {
        label: 'Calibration view',
        content: CompanyCalibrationViews,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
      },
      settings: {
        label: 'Settings',
        content: ReviewSettings,
        headerLabel: "My company's reviews",
        hide: () => !calcHasReviewSettingsAccess(),
      },
      reviewCreation: {
        label: 'Review creation',
        content: ReviewProcessV2Intent,
        hide: () => {
          const isSimplifiedReviewCreation = checkSimplifiedReviewCreationEnabled();
          if (!isSimplifiedReviewCreation) {
            return true;
          }

          return !calcHasReviewSettingsAccess();
        },
        // hideFromTabList: true,
      },
      embeddedAnalytics: {
        label: 'Insights',
        content: EmbeddedReviewsAnalytics,
        cohortId: -1,
        teamId: -1,
        headerLabel: "My company's reviews",
        hide: () => !(checkVisierAnalyticsEnabled() && getUserAccess().isReviewAdmin),
      },
      detailReports: {
        label: 'Insights',
        content: CompanyReviewDetailedReport,
        cohortId: -1,
        teamId: -1,
        headerLabel: "My company's reviews",
        hide: () =>
          !(checkReviewReportsEnabled() && (getUserAccess().isReviewAdmin || getUserAccess().isCustomReviewAdmin)),
      },
      calibratedResults: {
        label: 'Calibrated results',
        content: CompanyReviewsManage,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
      },
      completionStatus: {
        label: 'Completion status',
        content: CompanyReviewsManage,
        cohortId: -1,
        teamId: -1,
        hideFromTabList: true,
      },
    },
    engagement: {
      insights: { label: 'Manage', content: MyCompanyEngagementInsights, cohortId: -1, teamId: -1 },
      completionStatus: {
        label: 'Completion status',
        content: MyCompanyEngagementCompletionStatus,
        cohortId: -1,
        teamId: -1,
      },
      settings: {
        label: 'Settings',
        content: EngagementSettings,
        cohortId: -1,
        teamId: -1,
        headerLabel: "My company's engagement",
        hide: () => !(getUserAccess().isEngagementAdmin || getUserAccess().isCustomEngagementAdmin),
      },
      embeddedAnalytics: {
        label: 'Insights',
        content: EmbeddedEngagementAnalytics,
        cohortId: -1,
        teamId: -1,
        headerLabel: "My company's engagement",
        hide: () => !(getUserAccess().isEngagementAdmin || getUserAccess().isCustomEngagementAdmin),
      },
      surveyCreation: {
        label: 'Survey creation',
        content: SurveyCreation,
        cohortId: -1,
        teamId: -1,
        hide: () => !(getUserAccess().isEngagementAdmin || getUserAccess().isCustomEngagementAdmin),
        hideFromTabList: true,
      },
      previewSurvey: {
        label: 'Survey Preview',
        content: SurveyPreview,
        cohortId: -1,
        teamId: -1,
        hide: () => !(getUserAccess().isEngagementAdmin || getUserAccess().isCustomEngagementAdmin),
        hideFromTabList: true,
      },
    },
    disciplinaryActions: {
      pendingDisciplinaryActions: {
        label: 'Pending disciplinary actions',
        content: MyCompanyPendingDisciplinaryActions,
        cohortId: -1,
        teamId: -1,
      },
      allDisciplinaryActions: {
        label: 'All disciplinary actions',
        content: MyCompanyAllDisciplinaryActions,
        cohortId: -1,
        teamId: -1,
      },
      adminReports: {
        label: 'Reports',
        content: MyCompanyAdminReports,
        cohortId: -1,
        teamId: -1,
      },
      disciplinaryActionsSettings: {
        label: 'Settings',
        content: MyCompanyDisciplinaryActionsSettings,
        cohortId: -1,
        teamId: -1,
      },
    },
    lifecycle: {
      hire: {
        label: 'Hire',
        content: LifecycleHire,
        cohortId: -1,
        teamId: -1,
        headerLabel: '',
        hideFromTabList: true,
        hide: () => !checkLifecycleInsightsEnabled(),
      },
      retire: {
        label: 'Retire',
        content: LifecycleRetire,
        cohortId: -1,
        teamId: -1,
        headerLabel: '',
        hideFromTabList: true,
        hide: () => !checkLifecycleInsightsEnabled(),
      },
      onboard: {
        label: 'Onboard',
        content: LifecycleOnboard,
        cohortId: -1,
        teamId: -1,
        headerLabel: '',
        hideFromTabList: true,
        hide: () => !checkLifecycleInsightsEnabled(),
      },
      progress: {
        label: 'Progress',
        content: LifecycleProgress,
        cohortId: -1,
        teamId: -1,
        headerLabel: '',
        hideFromTabList: true,
        hide: () => !checkLifecycleInsightsEnabled(),
      },
    },
    compensation: {
      planning: {
        label: 'Compensation planning',
        content: MyCompanyCompensationPlanning,
        cohortId: -1,
        teamId: -1,
      },
      settings: {
        label: 'Settings',
        content: CompensationSettings,
        cohortId: -1,
        teamId: -1,
      },
      compensationCycleCreation: {
        label: 'Compensation cycle creation',
        content: CompensationCycleCreation,
        cohortId: -1,
        teamId: -1,
      },
      compensationRecommendation: {
        label: 'Compensation recommendation',
        content: CompensationRecommendation,
        cohortId: -1,
        teamId: -1,
      },
    },
  },
};
